import { BASVURU_OLUSTUR } from "../constants/requestUrls";

import { postRequest } from "../request";

const BasvuruOlustur = (props) => {
  let data = {};
  if (props !== undefined)
    data = JSON.stringify(props);
  return postRequest({ url: BASVURU_OLUSTUR, data });
}

export default BasvuruOlustur;